import { Plus, Search } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import type { ClientProfileStatus } from '../../types/case-management'

interface PageHeaderProps {
  onNew: () => void
}

export function PageHeader({ onNew }: PageHeaderProps): React.ReactElement {
  const { t } = useTranslation('cases')
  return (
    <div className="flex items-center justify-between">
      <div>
        <h1 className="text-2xl font-bold text-stone-900 dark:text-stone-100">
          {t('clients.title')}
        </h1>
        <p className="mt-1 text-sm text-stone-500 dark:text-stone-400">{t('clients.subtitle')}</p>
      </div>
      <button
        onClick={onNew}
        className="inline-flex items-center gap-2 rounded-lg bg-[#4e5e82] px-4 py-2 text-sm font-medium text-white hover:bg-[#5c6e94]"
      >
        <Plus className="h-4 w-4" />
        {t('clients.newClient')}
      </button>
    </div>
  )
}

interface ToolbarProps {
  searchQuery: string
  setSearchQuery: (value: string) => void
  statusFilter: ClientProfileStatus | ''
  setStatusFilter: (value: ClientProfileStatus | '') => void
}

export function ClientsToolbar(props: ToolbarProps): React.ReactElement {
  const { t } = useTranslation('cases')
  const { searchQuery, setSearchQuery, statusFilter, setStatusFilter } = props
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
      <div className="relative flex-1">
        <Search className="absolute top-1/2 left-3 h-4 w-4 -translate-y-1/2 text-stone-400" />
        <input
          type="text"
          placeholder={t('clients.searchPlaceholder')}
          value={searchQuery}
          onChange={(event) => {
            setSearchQuery(event.target.value)
          }}
          className="w-full rounded-lg border border-stone-200 bg-white py-2 pr-4 pl-10 text-sm focus:border-[#4e5e82] focus:ring-1 focus:ring-[#4e5e82] focus:outline-none dark:border-stone-700 dark:bg-stone-800 dark:text-stone-100"
        />
      </div>
      <select
        value={statusFilter}
        onChange={(event) => {
          setStatusFilter(event.target.value as ClientProfileStatus | '')
        }}
        className="rounded-lg border border-stone-200 bg-white px-3 py-2 text-sm focus:border-[#4e5e82] focus:ring-1 focus:ring-[#4e5e82] focus:outline-none dark:border-stone-700 dark:bg-stone-800 dark:text-stone-100"
      >
        <option value="">{t('clients.allStatuses')}</option>
        <option value="active">{t('status.active')}</option>
        <option value="inactive">{t('status.inactive')}</option>
        <option value="archived">{t('caseStatus.archived')}</option>
      </select>
    </div>
  )
}
